// TODO
//Need to extract Login form and logic from application
//

import React from 'react';
import { useState } from 'react';
import { Card, Row, Col, Form, Alert } from 'react-bootstrap';
import { login } from '../services/authentication.service';
import LoginModel from './login.model';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from './UI/button';
import { ResetPasswordProps } from './types/reset-password-props';
import withAlert from '../HOCs/withAlert';
import LoginWithGoogle from './google-login';
import LoginWithFacebook from './facebook-login';
import './auth-forms.scss';

export function LoginForm({
  error = '',
  setError,
  message = '',
  setMessage
}: ResetPasswordProps) {
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || { pathname: '/app/trips' };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const form = e.currentTarget;
      const { usernameInput, passwordInput } = form;
      const loginModel: LoginModel = {
        email: usernameInput.value,
        password: passwordInput.value
      };

      setValidated(true);
      const success = await login(loginModel);

      if (success) {
        loginSuccess(success);
      } else {
        setError('Login Failed. Please check your credentials and try again.');
      }
    } catch (error: any) {
      setError('Login Failed. Please check your credentials and try again.');
    }
  };

  const loginSuccess = async (success: boolean) => {
    if (success) {
      navigate(from, { replace: true });
    }
  };

  return (
    <div className='login w-100'>
      <Row className='g-0 justify-content-md-center'>
        {/* <Col
          md='6'
          className='bg-border-color-gray position-relative'
        >
          <Card.Img
            src='https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp'
            alt='login form'
            className='w-100 h-100 object-fit-cover position-absolute'
            style={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0
            }}
          />
        </Col> */}
        <Col
          // md='6'
          className='d-flex align-items-center justify-content-center position-relative auth-col overflow-y-auto overflow-x-hidden'
        >
          <div className='gradient-bg-login'></div>
          <div className='auth-form-inner'>
            <div className='d-flex flex-column'>
              <div className='d-flex flex-column text-center'>
                <span className='h1 fw-bold'>
                  Travel
                  <span className='text-primary'>Hearts</span>
                </span>
                <h3 className='fw-bold'>Log In</h3>
              </div>

              <h5
                className='fw-normal mt-2 font-libre fs-6 mx-auto text-dark-2'
                style={{ letterSpacing: '1px', marginBottom: '32px' }}
              >
                Welcome back! Please enter your details.
              </h5>
              {error && <Alert variant='danger'>{error}</Alert>}

              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <Form.Group
                  style={{ marginBottom: '20px' }}
                  controlId='usernameInput'
                >
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type='email'
                    placeholder='Enter here'
                    required
                    autoComplete='email'
                  />
                </Form.Group>

                <Form.Group
                  style={{ marginBottom: '24px' }}
                  controlId='passwordInput'
                >
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type='password'
                    placeholder='••••••••'
                    required
                    formNoValidate
                    autoComplete='current-password'
                  />
                </Form.Group>
                <div
                  className='d-flex justify-content-between fs-7'
                  style={{ marginBottom: '24px' }}
                >
                  <div
                    className='d-flex flex-row cursor-pointer'
                    style={{ gap: '8px' }}
                  >
                    <input
                      id='rememberMe'
                      type='checkbox'
                    />
                    <label htmlFor='rememberMe'>Remember me</label>
                  </div>
                  <a
                    className='small hover-underline text-primary fw-bold font-libre'
                    href='/forgot-password-email'
                  >
                    Forgot password?
                  </a>
                </div>
                <Button
                  type='submit'
                  className='font-libre'
                  width='full'
                  color='dark'
                  size='md'
                  fontSize='sm'
                  fontFamily='libre'
                >
                  Log In
                </Button>
                <p
                  className='text-center font-rubik fs-7'
                  style={{ margin: '8px 0' }}
                >
                  or
                </p>
                <div className='grid column-gap-2'>
                  <LoginWithGoogle
                    isSignUp={false}
                    loginSuccess={loginSuccess}
                  />
                  {/* <Button
                    fontFamily='rubik'
                    variant='dark'
                    className='d-flex align-items-center justify-content-center px-1 g-col-6'
                    style={{ gap: '8px' }}
                  >
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M19.8689 10.2281C19.8698 9.54663 19.8117 8.8664 19.6955 8.19482H10.1997V12.046H15.6385C15.5272 12.6611 15.2916 13.2475 14.946 13.7697C14.6004 14.292 14.1518 14.7393 13.6274 15.0848V17.5846H16.8733C18.7739 15.8444 19.8689 13.271 19.8689 10.2281Z'
                        fill='white'
                      />
                      <path
                        d='M10.1997 20C12.9169 20 15.2049 19.1139 16.8733 17.5862L13.6274 15.0864C12.7239 15.6947 11.5604 16.0419 10.1997 16.0419C7.57328 16.0419 5.34408 14.2836 4.54693 11.9143H1.20312V14.4906C2.0412 16.1467 3.32629 17.5389 4.91493 18.5118C6.50358 19.4847 8.33324 19.9999 10.1997 20Z'
                        fill='white'
                      />
                      <path
                        d='M4.54686 11.914C4.12543 10.6724 4.12543 9.32793 4.54686 8.08639V5.51013H1.20305C0.498032 6.90333 0.130859 8.44096 0.130859 10.0002C0.130859 11.5594 0.498032 13.097 1.20305 14.4902L4.54686 11.914Z'
                        fill='white'
                      />
                      <path
                        d='M10.1997 3.95879C11.6356 3.93549 13.0231 4.47429 14.0623 5.45872L16.9362 2.60469C15.1139 0.904883 12.6996 -0.0283412 10.1997 0.000656061C8.33324 0.000740536 6.50358 0.515984 4.91494 1.48886C3.32629 2.46174 2.0412 3.85397 1.20312 5.5101L4.54693 8.08636C5.34408 5.71704 7.57328 3.95879 10.1997 3.95879Z'
                        fill='white'
                      />
                    </svg>
                    Log in with Google
                  </Button> */}
                  <LoginWithFacebook
                    isSignUp={false}
                    loginSuccess={loginSuccess}
                  />
                  {/* <Button
                    fontFamily='rubik'
                    variant='dark'
                    className='d-flex align-items-center justify-content-center px-1 g-col-6'
                    style={{ gap: '8px' }}
                  >
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g clipPath='url(#clip0_252_671)'>
                        <path
                          d='M20 10C20 4.4772 15.5228 0 10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10H20Z'
                          fill='white'
                        />
                        <path
                          d='M13.9168 13.056L14.478 10H11.2116V8.91923C11.2116 7.30443 11.8452 6.68323 13.4848 6.68323C13.994 6.68323 14.404 6.69563 14.64 6.72043V3.95043C14.1928 3.82603 13.0996 3.70203 12.466 3.70203C9.12437 3.70203 7.58397 5.27963 7.58397 8.68323V10H5.52197V13.056H7.58397V19.7056C8.35757 19.8976 9.16677 20 9.99957 20C10.4096 20 10.814 19.9748 11.2112 19.9268V13.056H13.9168Z'
                          fill='#2D2D2D'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_252_671'>
                          <rect
                            width='20'
                            height='20'
                            fill='white'
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Log in with Facebook
                  </Button> */}
                </div>
              </Form>
              <p
                style={{ marginTop: '24px' }}
                className='pb-lg-2 fs-7 text-center'
              >
                Don't have an account?{' '}
                <a
                  href='/signup'
                  className='text-primary fw-bold font-libre'
                >
                  Create account
                </a>
              </p>
            </div>
          </div>
          <p
            className='position-absolute position-x-center font-libre fs-7 fw-bold text-dark-2'
            style={{ bottom: '32px' }}
          >
            © Travel Hearts 2024
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default withAlert(LoginForm);
